import React from 'react';

import style from './style.module.scss';

interface IProps {
  show: boolean;
}

const TableLoadingTrigger = React.forwardRef<HTMLTableRowElement, IProps>(({ show }, ref) =>
  show ? <tr className={style.tableLoadingTrigger} ref={ref} /> : null,
);

export default TableLoadingTrigger;
